import React from 'react';
import { AddCompanyUserPopup, ModalWrapper } from '@shared/ui-components';
import { DialogWrapper } from 'common/UIKit/dialogs/dialog-wrapper';
import { RoleData } from './interfaces';

interface Props {
  closeAddPeopleDialog: () => void;
  onInvitePeople: (peopleInvites: Array<{ email: string, role: RoleData }>) => void;
  isAddGuest: boolean;
  emptySeatCount: number;
  userRoles: RoleData[];
  guestRoles: RoleData[];
}

export const COMPANY_INFO_ADD_PEOPLE_DIALOG = 'COMPANY_INFO_ADD_PEOPLE_DIALOG';

const AddCompanyInfoPopupComponent: React.FC<Props> = ({
  closeAddPeopleDialog,
  onInvitePeople,
  isAddGuest,
  emptySeatCount,
  userRoles,
  guestRoles,
}) => {
  return (
    <DialogWrapper name={COMPANY_INFO_ADD_PEOPLE_DIALOG}>
      <ModalWrapper onExit={closeAddPeopleDialog}>
        <AddCompanyUserPopup
          userRoles={isAddGuest ? guestRoles : userRoles}
          title="Add people to company"
          buttonTitle="Share"
          onFormSubmit={onInvitePeople}
          userLimit={!isAddGuest ? emptySeatCount : null}
        />
      </ModalWrapper>
    </DialogWrapper>
  );
};

export const AddCompanyInfoPopup = React.memo(AddCompanyInfoPopupComponent);
